import { render, staticRenderFns } from "./dropdown-client-search.vue?vue&type=template&id=4261d004&scoped=true&"
import script from "./dropdown-client-search.vue?vue&type=script&lang=js&"
export * from "./dropdown-client-search.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-client-search.vue?vue&type=style&index=0&id=4261d004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261d004",
  null
  
)

export default component.exports